<template>
  <b-container class="mt-5">
    <h3>Registrieren:</h3>
    <hr class="mt-4 mb-4">
    <h4>Name:</h4>
    <b-form-input
        id="input-1"
        v-model="invitation.name"
        class="mb-2"
        readonly
    />
    <h4>Passwort:</h4>
    <b-form-input
        v-model="password"
        required
        class="mb-2"
        type="password"
    />

    <h4>Passwort bestätigen:</h4>
    <b-form-input
        v-model="password_confirm"
        required
        class="mb-2"
        type="password"
        :state="password === password_confirm && password !== ''"
    />
    <hr class="mt-4 mb-4">
    <b-button variant="outline-success" @click="register({ key: registerKey, password })" block>Registrieren</b-button>
  </b-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Register",
  data() {
    return {
      password: "",
      password_confirm: "",
    }
  },
  computed: {
    ...mapGetters([
      'getStoredInvitation'
    ]),
    registerKey() {
      const regex = /\/Registrieren\/(\w*)/;
      const str = this.$route.path
      return str.replace(regex, "$1");
    },
    invitation() {
      return this.getStoredInvitation
    }
  },
  methods: {
    ...mapActions([
      'getInvitation',
      'register'
    ]),
  },
  mounted() {
    this.getInvitation(this.registerKey)
  }
}
</script>

<style scoped>

</style>
